module.exports = __webpack_public_path__ + "static/img/info4.62ed62d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity2023114/info4.png
// module id = fh8j
// module chunks = 0